import {Component, Input, OnInit} from '@angular/core';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-card-chart-ratings',
  templateUrl: './card-chart-ratings.component.html',
  styleUrls: ['./card-chart-ratings.component.scss']
})
export class CardChartRatingsComponent implements OnInit {

  @Input() data: [];

  chartOptions: {};
  Highcharts = Highcharts;

  constructor() { }

  ngOnInit(): void {
    this.chartOptions = {
      colors: ['rgb(239,128,49)', 'rgb(129,186,241)', 'rgb(94,187,75)'],
      chart: {
        type: 'column',
        inverted: true,
        polar: true,
        backgroundColor: null
      },
      title: {
        text: null
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      tooltip: {
        outside: true
      },
      pane: {
        size: '85%',
        innerSize: '20%',
        endAngle: 270
      },
      xAxis: {
        tickInterval: 1,
        labels: {
          align: 'right',
          useHTML: true,
          allowOverlap: false,
          style: {
            fontSize: '13px'
          }
        },
        lineWidth: 0,
        categories: [
          '<i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i>',
          '<i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i>',
          '<i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i>',
          '<i class="fas fa-star"></i><i class="fas fa-star"></i>',
          '<i class="fas fa-star"></i>',
          '<i class="far fa-star"></i>'
        ]
      },
      yAxis: {
        title: {
          enabled: true,
          text: 'Portfolios'
        },
        crosshair: {
          enabled: true,
          color: '#333'
        },
        lineWidth: 0,
        reversedStacks: false,
        endOnTick: true,
        showLastLabel: true,
        gridLineDashStyle: "Dash",
        gridLineColor: 'grey',
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          borderWidth: 0,
          pointPadding: 0,
          groupPadding: 0.15
        }
      },
      legend: false,
      series: this.data
    }
  }

}
